// Module
var code = " <md-content class=\"maintenance-message\"> <h1 translate=\"{{ $ctrl.i18n.title }}\"></h1> <h2 translate=\"{{ $ctrl.i18n.subTitle }}\"></h2> <p translate=\"{{ $ctrl.i18n.primaryContent }}\"></p> <p translate=\"{{ $ctrl.i18n.secondaryContent }}\"></p> </md-content> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/states/accountManagement/maintenance/maintenance.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;